export enum Languages {
  En = 'en',
  De = 'de',
}

export const languages = Object.values(Languages);
